module.exports = __webpack_public_path__ + "img/fidelity.0cb87f47.png";